import { debounce } from 'lodash-es'
import {
  executeMarkNotificationRead,
  refetchListMyNotifications,
} from 'src/services/apollo/notification'

const notiIdSet = new Set<string>()

export function ackNotification(notiId: string) {
  notiIdSet.add(notiId)

  debounce(() => performMutateAck(), 2000)()
}

async function performMutateAck() {
  const notiIds = Array.from(notiIdSet)
  if (notiIds.length === 0) return
  try {
    await executeMarkNotificationRead({ ids: notiIds })
    notiIds.forEach(id => notiIdSet.delete(id))
    refetchListMyNotifications() // revalidate noti list
  } catch (e) {
    console.log(e)
  }
}
